var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenShareOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0,12.1c0-3,0-6,0-8.9c0,0,0,0,0-0.1c0.3-1.2,1-1.8,2.2-1.8c4.5,0,9,0,13.6,0c1.3,0,2.2,0.9,2.2,2.2 c0,2.8,0,5.5,0,8.3c0,0.2,0,0.4-0.1,0.5c-0.2,1-1.1,1.6-2.1,1.6c-2,0-4,0-5.9,0c-0.1,0-0.1,0-0.2,0c0,0.5,0,0.9,0,1.4 c1.2,0,2.4,0,3.6,0c0,0.5,0,0.9,0,1.4c-2.9,0-5.8,0-8.7,0c0-0.5,0-0.9,0-1.4c1.2,0,2.4,0,3.6,0c0-0.5,0-0.9,0-1.4 c-0.1,0-0.1,0-0.2,0c-2,0-3.9,0-5.9,0c-0.7,0-1.3-0.3-1.8-0.9C0.2,12.7,0.1,12.4,0,12.1z M9,12.5c2.3,0,4.5,0,6.8,0 c0.5,0,0.8-0.3,0.8-0.8c0-2.7,0-5.5,0-8.2c0-0.6-0.3-0.8-0.8-0.8c-4.5,0-9,0-13.5,0c-0.6,0-0.8,0.3-0.8,0.8c0,2.7,0,5.4,0,8.2 c0,0.6,0.3,0.8,0.8,0.8C4.5,12.5,6.7,12.5,9,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.3,6.5C7.6,7.2,6.9,7.9,6.2,8.5c-0.3-0.3-0.7-0.7-1-1C6.5,6.3,7.8,5.1,9,3.8c1.2,1.2,2.5,2.5,3.7,3.7 c-0.3,0.3-0.6,0.6-1,1c-0.7-0.7-1.4-1.4-2.1-2.1c0,2.3,0,1.9,0,4.2c-0.5,0-0.9,0-1.4,0C8.3,8.4,8.3,8.8,8.3,6.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShareOff);
export default __webpack_public_path__ + "static/media/screenShareOff.eaee1f665a49dc0be6c13fb5e1215f8a.svg";
export { ForwardRef as ReactComponent };